var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.1419 22.0854C7.46637 21.5866 5.97491 20.6604 4.79393 19.4333C5.23449 18.9111 5.5 18.2365 5.5 17.4998C5.5 15.843 4.15685 14.4998 2.5 14.4998C2.39977 14.4998 2.3007 14.5047 2.20299 14.5143C2.0699 13.8636 2 13.1899 2 12.4998C2 11.4545 2.16039 10.4467 2.45789 9.49953C2.47191 9.49972 2.48594 9.49982 2.5 9.49982C4.15685 9.49982 5.5 8.15667 5.5 6.49982C5.5 6.02418 5.38931 5.57439 5.19228 5.17481C6.34877 4.0995 7.76026 3.29477 9.32603 2.86133C9.8222 3.83385 10.8333 4.49982 12 4.49982C13.1667 4.49982 14.1778 3.83385 14.674 2.86133C16.2397 3.29477 17.6512 4.0995 18.8077 5.17481C18.6107 5.57439 18.5 6.02418 18.5 6.49982C18.5 8.15667 19.8431 9.49982 21.5 9.49982C21.5141 9.49982 21.5281 9.49972 21.5421 9.49953C21.8396 10.4467 22 11.4545 22 12.4998C22 13.1899 21.9301 13.8636 21.797 14.5143C21.6993 14.5047 21.6002 14.4998 21.5 14.4998C19.8431 14.4998 18.5 15.843 18.5 17.4998C18.5 18.2365 18.7655 18.9111 19.2061 19.4333C18.0251 20.6604 16.5336 21.5866 14.8581 22.0854C14.4714 20.8757 13.338 19.9998 12 19.9998C10.662 19.9998 9.5286 20.8757 9.1419 22.0854Z",
    stroke: "#403B37",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 16C13.933 16 15.5 14.433 15.5 12.5C15.5 10.567 13.933 9 12 9C10.067 9 8.5 10.567 8.5 12.5C8.5 14.433 10.067 16 12 16Z",
    stroke: "#403B37",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.6a241b51110b84bf730f93a0e2c1e1c7.svg";
export { ForwardRef as ReactComponent };